import { Controller } from 'stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static values = { kind: String };

  dismiss() {
    const body = { kind: this.kindValue };
    new FetchRequest('POST', '/user_actions', { body }).perform().catch(console.error);
    this.element.remove();
  }
}
